import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchCampaignDetail } from '..';

export function useCampaignDetail(campaignId: string) {
  const queryKeys = useQueryKeys();

  return useQuery({
    enabled: campaignId.length > 0,
    queryKey: queryKeys.campaign.detail(campaignId),
    queryFn: async ({ signal }) => FetchCampaignDetail(campaignId, signal),
    staleTime: 30_000,
  });
}
